// ComingSoon.js
import React, { useEffect, useState } from "react";
import "./announcement.css";
import Tvborder from "../../../../components/Tvborder";
import { checkRefId, GAuthToken, getUserDetails, telegramAuthToken } from "../../../../apis/user";
import useUserInfo from "../../../../Hooks/useUserInfo";
import { formatNumber, formatNumberWithCommas } from "../../../../helpers/helpers";
import { logPageView } from "../../../../components/analytics";
import { ShieldCheckIcon } from "lucide-react";
let userData;
const QuegaAnnouncement = () => {
  const [balanceRewards, setBalanceRewards] = useState(null);
  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
  useUserInfo();
  const GetWebId = localStorage.getItem("GoogleId_Web");
  const GetWebName = localStorage.getItem("UserName_Web");
  const DefaultTelegramId =
  GetWebId || process.env.REACT_APP_DEFAULT_TELEGRAM_ID;
const DefaultTelegramName =
  GetWebName || process.env.REACT_APP_DEFAULT_TELEGRAM_NAME;
  const IsLocalServer =
  process.env.REACT_APP_IS_LOCAL_SERVER == "true" ? true : false;
  const userProfile = localStorage.getItem("userProfile");
  const parsedUserProfile = (() => {
    try {
      return userProfile ? JSON.parse(userProfile) : null;
    } catch {
      return null;
    }
  })();
useEffect(() => {
  logPageView("Announcement", "Announcement page");
}, []);
  useEffect(() => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.ready();
      window.Telegram.WebApp.expand();
    }
    const rawInitDataString = window.Telegram?.WebApp?.initData;

    const authenticateUser = async () => {
      let authResult;

      if (rawInitDataString || IsLocalServer) {
        // Telegram authentication
        authResult = await telegramAuthToken(rawInitDataString);
      } else {
        // Google authentication
        authResult = await GAuthToken();
      }

      if (authResult) {
        // Authentication successful, proceed with getting user details
        const urlParams = new URLSearchParams(window.location.href);
        const RefId = localStorage.getItem("RefId");
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        userData = window.Telegram?.WebApp?.initDataUnsafe?.user;
        const startParam = RefId || params.get("tgWebAppStartParam");
        const GetWebId = params.get("auth");

        if (userData || GetWebId == "success") {
          let loginData;

          // GAuth (web) user: no Telegram userData, use web credentials
          if (!userData && GetWebId == "success") {
            const data1 = {
              name: DefaultTelegramName,
              telegramId: DefaultTelegramId,
            };
            const userDetailsResponse = await getUserDetails(data1);
            console.log(userDetailsResponse,'userDetailsResponse');
            
            if (userDetailsResponse?.balanceRewards !== undefined) {
              setBalanceRewards(userDetailsResponse.balanceRewards);
            }
            return;
          }

          if (startParam && startParam !== "undefined") {
            // Handle different startParam cases
            if (startParam.length === 8) {
              localStorage.setItem(`promoCode_${userData?.id}`, startParam);
              localStorage.setItem(
                `navigateToDoandEarn_${userData?.id}`,
                "true"
              );
            } else if (startParam.length == 9) {
              localStorage.setItem(
                `navigateToSquadPage_${userData?.id}`,
                "true"
              );
              localStorage.setItem(`squadCode_${userData?.id}`, startParam);
            } else if (startParam.length == 6) {
              try {
                const response = await checkRefId(startParam);
                if (response.data.exists) {
                  loginData = {
                    name: userData?.first_name,
                    telegramId: String(userData?.id),
                    referredById: startParam,
                  };
                } else {
                  loginData = {
                    name: userData?.first_name,
                    telegramId: String(userData?.id),
                    marketingRefID: startParam,
                  };
                }
                const userDetailsResponse = await getUserDetails(loginData);
                  console.log(userDetailsResponse,'userDetailsResponse');
                if (userDetailsResponse?.balanceRewards !== undefined) {
                  setBalanceRewards(userDetailsResponse.balanceRewards);
                }
              } catch (error) {
                console.error("Error checking refId:", error);
                loginData = {
                  name: userData?.first_name,
                  telegramId: String(userData?.id),
                  marketingRefID: startParam,
                };
                const userDetailsResponse = await getUserDetails(loginData);
                  console.log(userDetailsResponse,'userDetailsResponse');
                if (userDetailsResponse?.balanceRewards !== undefined) {
                  setBalanceRewards(userDetailsResponse.balanceRewards);
                }
              }
              return;
            }

            // Determine marketing campaign based on startParam value
            let marketingCampaign = null;
            if (startParam == 1) {
              marketingCampaign = null; // superUser is true
            } else if (startParam == 2) {
              marketingCampaign = null; // influencerUser is true
            } else if (startParam == 3) {
              marketingCampaign = "iplFanPark";
            } else if (startParam == 4) {
              marketingCampaign = "iplFanPark-pamplate";
            } else if (startParam == 5) {
              marketingCampaign = "iplFanPark-cap";
            } else if (startParam >= 6 && startParam <= 100) {
              marketingCampaign = `marketingLink${startParam - 5}`;
            }

            loginData = {
              name: userData?.first_name,
              telegramId: String(userData?.id),
              referredById: startParam,
              superUser: startParam == 1 ? true : false,
              influencerUser: startParam == 2 ? true : false,
              marketingCampaign: marketingCampaign,
            };
          } else {
            loginData = {
              name: userData?.first_name,
              telegramId: String(userData?.id),
              superUser: startParam == 1 ? true : false,
              influencerUser: startParam == 2 ? true : false,
              marketingCampaign: null,
            };
          }

          const userDetailsResponse = await getUserDetails(loginData);
            console.log(userDetailsResponse,'userDetailsResponse');
          if (userDetailsResponse?.balanceRewards !== undefined) {
            setBalanceRewards(userDetailsResponse.balanceRewards);
          }

          updateUserInfo((prev) => ({
            ...prev,
            telegramDetails: userData,
          }));
        } else {
          // Fallback for when userData is not available
          const data1 = {
            name: DefaultTelegramName,
            telegramId: DefaultTelegramId,
          };
          const userDetailsResponse = await getUserDetails(data1);
            console.log(userDetailsResponse,'userDetailsResponse');
          if (userDetailsResponse?.balanceRewards !== undefined) {
            setBalanceRewards(userDetailsResponse.balanceRewards);
          }
        }
      } else {
        console.error("Authentication failed:", authResult?.error);
      }
    };

    authenticateUser();
  }, []);
  const tokenBalance = balanceRewards?balanceRewards: parsedUserProfile?.balanceRewards ;
  const LEAP_URL = "https://questsandgames.com/";

  const handleOpenLink = (e) => {
    const tg = window.Telegram?.WebApp;
    if (tg?.openLink) {
      e.preventDefault();
      tg.openLink(LEAP_URL);
      return;
    }
    // In browser: allow default <a> navigation (don't preventDefault)
  };
  return (
    <div className="tv-border-wrapper">
      <Tvborder />
      <div className="banner-page quest-announcement-page">
        <div className="spinning-animation-sv" />
        <div className="heads-up-container">
          <div className="content-wrapper quest-content-wrapper">
            {/* Main headline - level-up style */}
            <h1 className="quest-main-title">
              <span className="quest-title-line">Time for a</span>
              <span className="quest-title-accent">Big Shift!</span>
            </h1>

            <p className="quest-subtitle">
              TheMemeTV is getting amped up as <span className="quest-brand">Quests & Games</span>.
            </p>

            {/* Token vault card - gamified */}
            <div className="quest-vault-card">
              <div className="quest-vault-header">
                <span className="quest-vault-icon"><ShieldCheckIcon className="w-4 h-4" /></span>
                <span>Your existing $MEMETV tokens</span>
              </div>
              <div className="quest-vault-value">
                <span className="quest-token-icon">
                  <img
                    src="https://d1ccopf5cw1hft.cloudfront.net/s3data/meme-logo.svg"
                    alt="$MEMETV"
                  />
                </span>
                <span className="quest-token-amount">{ formatNumberWithCommas(tokenBalance)}</span>
              </div>
            </div>

            <p className="quest-reassurance">
              Don't worry!! Your tokens are securely vaulted and carried forward.
            </p>

            {/* CTA - Leap In */}
            <a
              href={LEAP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="quest-cta-button"
              onClick={handleOpenLink}
              style={{ pointerEvents: "auto" }}
            >
              <span className="quest-cta-text">Leap In</span>
              <span className="quest-cta-arrow">→</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuegaAnnouncement;
